module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (4).380aa8af.jpeg";